import React from "react";
import styled from "styled-components";

import { Button } from "../../../../atoms";
import { IconChevron } from "../../../../atoms/icons";
import { device } from "../../../../../../utils";

const StyledButton = styled(Button)`
  width: 100%;

  &:active {
    ${({ theme, disabled }) =>
      !disabled && `background-color: ${theme.colours.ruubyLightGrey}`};
  }

  @media ${device.tablet} {
    max-width: 335px;
  }
`;

const InnerContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const ButtonText = styled.span`
  font-family: ${({ theme }) => theme.type.fonts.main};
  font-size: ${({ theme }) => theme.type.sizes.size16};
  font-weight: 400;
  line-height: ${({ theme }) => theme.type.sizes.size16};
  color: ${({ theme }) => theme.colours.buttonText};
`;

const IconContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 6px;

  svg {
    fill: ${({ theme }) => theme.colours.buttonText};
  }
`;

interface Props {
  isLoading: boolean;
  onCheckout(): void;
}

export const CheckoutButton = ({
  isLoading,
  onCheckout,
}: Props): JSX.Element => (
  <StyledButton size="small" onClick={onCheckout} disabled={isLoading}>
    <InnerContainer>
      <ButtonText>Continue to Checkout</ButtonText>
      <IconContainer>
        <IconChevron />
      </IconContainer>
    </InnerContainer>
  </StyledButton>
);
